var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/fax") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 16 16 16 16 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/fax",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,16 L13,16 L13,9 L3,9 L3,16 Z M4,15 L12,15 L12,10 L4,10 L4,15 Z",
    id: "Fill-1",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,4 L2,4 C0.896,4 0,4.896 0,6 L0,11 C0,12.104 0.896,13 2,13 L3,13 L3,9 L13,9 L13,13 L14,13 C15.104,13 16,12.104 16,11 L16,6 C16,4.896 15.104,4 14,4",
    id: "Fill-2",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#4B4B4B",
    mask: "url(#mask-2)",
    points: "5 12 11 12 11 11 5 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#4B4B4B",
    mask: "url(#mask-2)",
    points: "5 14 11 14 11 13 5 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5 L13,5.5 L13,0 L3,0 L3,5.5 Z M4,4.5 L12,4.5 L12,1 L4,1 L4,4.5 Z",
    id: "Fill-7",
    fill: "#4B4B4B",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.dc75ba8899ffd38f5c2b7fb48109ac08.svg";
export { ForwardRef as ReactComponent };